import InnBLink from './inn-b-link';

export { InnBLink };
